var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.062,23.296h-5.404v-5.372c0-1.104-0.896-2-2-2s-2,0.896-2,2V24.5l-4.685,4.685c-4.31-3.668-9.888-5.888-15.977-5.888 c-13.616,0-24.693,11.078-24.693,24.694s11.078,24.693,24.693,24.693c13.616,0,24.693-11.077,24.693-24.693 c0-6.09-2.22-11.668-5.888-15.978l4.716-4.716h6.545c1.104,0,2-0.896,2-2S79.166,23.296,78.062,23.296z M68.688,47.99 c0,11.41-9.283,20.693-20.693,20.693S27.302,59.4,27.302,47.99c0-11.411,9.283-20.694,20.693-20.694 c4.987,0,9.566,1.774,13.143,4.722l-2.345,2.345c-2.971-2.359-6.719-3.78-10.798-3.78c-9.597,0-17.405,7.808-17.405,17.406 s7.808,17.405,17.405,17.405c9.598,0,17.405-7.808,17.405-17.405c0-4.079-1.42-7.827-3.779-10.798l2.345-2.345 C66.915,38.424,68.688,43.004,68.688,47.99z M61.4,47.99c0,7.392-6.014,13.405-13.405,13.405S34.59,55.382,34.59,47.99 c0-7.392,6.014-13.406,13.405-13.406c2.975,0,5.718,0.986,7.945,2.633l-2.547,2.547c-1.552-1.022-3.405-1.621-5.398-1.621 c-5.43,0-9.847,4.417-9.847,9.847s4.417,9.847,9.847,9.847s9.847-4.417,9.847-9.847c0-1.993-0.599-3.846-1.621-5.398l2.547-2.547 C60.414,42.272,61.4,45.015,61.4,47.99z M53.842,47.99c0,3.224-2.623,5.847-5.847,5.847s-5.847-2.623-5.847-5.847 c0-3.224,2.623-5.847,5.847-5.847c0.882,0,1.715,0.202,2.466,0.553l-3.88,3.88c-0.781,0.781-0.781,2.047,0,2.828 c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586l3.88-3.88C53.64,46.275,53.842,47.108,53.842,47.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.6896f16bcbb323a947ef2854995e77fd.svg";
export { ForwardRef as ReactComponent };